import { AccountFailure } from '@/stores/appStore';

const MESSAGES: Record<AccountFailure['reason'], string> = {
	refused: 'Vous n\'avez pas les autorisations pour accéder à ce compte.',
	unavailable: 'Ce compte n\'a pas pu être chargé. Réessayez dans quelques instants.',
};

const accountFailureMessage = (failure: AccountFailure) => MESSAGES[failure.reason];

export default accountFailureMessage;
